import Vue from 'vue';
import axios from './axios.js';
import {AccountInfo} from './axios.js';

const getAuth = () => {
  return new Promise(async (resolve, reject) => {
    let account = AccountInfo.getAccountFromSys();
    if (account && (account.customerId || account.accountType)) {
      let key = account.customerId ? 'auth_customer_' + account.customerId : `auth_${account.accountType}_${account.accountId}`;
      if (sessionStorage && sessionStorage.getItem(key)) {
        resolve(sessionStorage.getItem(key));
      } else {
        let data = {};
        let {data: res} = await axios({
          url: '/v2/authority/user_feature_list'
        });
        if (res.success) {
          sessionStorage.setItem(key, JSON.stringify(res.result));
          resolve(res.result);
        } else {
          resolve([]);
        }
      }
    } else {
      reject([]);
    }
  });
}

function find(auth, key) {
  let reg = new RegExp(key, 'g');
  return reg.test(auth);
  /*
  var isRegExp = key.indexOf('/') === 0;
  let reg = i
  key = isRegExp ? eval(key) : key;
  for (var i = 0, l = auth.length; i < l; i++) {
    if (isRegExp && key.test(auth[i])) {
      return true
    } else if (auth[i] === key) {
      // debugger
      return true;
    }
  }
  return false;
  */
}

Vue.directive('auth', {
  bind: function(el, binding) {
    getAuth().then(function(auth) {
      if (binding.value && !find(auth, binding.value)) {
        el.remove()
      }
    }, function(err) {
      el.remove()
    });
  }
});


export default {
  clearAuth() {
    var G = window.GLOBAL;
    var userInfo = G.userInfo;
    var key = "auth__customer_";

    if (userInfo) {
      key += userInfo.customerId;
      if (sessionStorage && sessionStorage.getItem(key)) {
        sessionStorage.removeItem(key);
      }
    }
  },
  getAuth: getAuth,
  find: find
}
